<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29.927"
    height="16.328"
    viewBox="0 0 29.927 16.328"
  >
    <g transform="translate(-410.537 -400.336)">
      <g>
        <path
          d="M435.709,412.311h-20.4l.033-.534a50.059,50.059,0,0,1,1.295-8.671l.586.03.224-.144a4.525,4.525,0,0,0,1.094.847c.68.443,2.046-.3,2.763-.8l-1.009-2.7.948.38a49.391,49.391,0,0,1,5.387,2.545,20.381,20.381,0,0,0,4.441,1.563,15.413,15.413,0,0,1,3.813,1.352c1.984,1.256.959,5.584.915,5.767Zm-19.441-1h18.753c.238-1.231.458-3.61-.574-4.264a15.2,15.2,0,0,0-3.581-1.251,20.828,20.828,0,0,1-4.628-1.639,47.44,47.44,0,0,0-4.337-2.1l.51,1.361-.294.232c-.262.2-2.592,1.989-4.014,1.059-.333-.217-.59-.4-.788-.554a48.942,48.942,0,0,0-1.053,7.156Z"
          fill="#777"
        />
        <rect
          width="19.91"
          height="1"
          transform="translate(415.891 408.857)"
          fill="#777"
        />
        <rect
          width="2.759"
          height="0.999"
          transform="translate(423.872 405.285) rotate(-60.477)"
          fill="#777"
        />
        <rect
          width="2.484"
          height="1"
          transform="matrix(0.512, -0.859, 0.859, 0.512, 425.711, 406.009)"
          fill="#777"
        />
      </g>
      <rect
        width="4.044"
        height="1"
        transform="translate(411.84 415.915) rotate(-46.266)"
        fill="#777"
      />
      <rect
        width="1"
        height="3.859"
        transform="matrix(0.73, -0.684, 0.684, 0.73, 435.251, 413.848)"
        fill="#777"
      />
      <rect
        width="3.915"
        height="1.001"
        transform="matrix(0.927, -0.375, 0.375, 0.927, 410.537, 412.522)"
        fill="#777"
      />
      <rect
        width="1"
        height="3.988"
        transform="translate(436.474 412.447) rotate(-60.774)"
        fill="#777"
      />
      <rect
        width="1"
        height="3.59"
        transform="translate(436.755 409.959) rotate(-68.754)"
        fill="#777"
      />
      <rect
        width="3.884"
        height="1"
        transform="translate(410.597 408.993)"
        fill="#777"
      />
    </g>
  </svg>
</template>
